/* eslint-disable react/prop-types */
import React from 'react';

export default function PortalButton({ variant, text, onClick, classes }) {
  return (
    <button
      onClick={onClick}
      className={
        'btn text-sm rounded-lg py-3 my-1 px-5 ' +
        (variant === 'primary'
          ? 'bg-blue-800 hover:bg-blue-500 text-white  '
          : 'bg-white hover:bg-portal-100 text-blue-600 border border-blue-600 ') +
        classes
      }>
      {text.replace(/\b\w/g, (l) => l.toUpperCase())}
    </button>
  );
}
